import axios from "axios";

export const SEARCH_RADIUS_METERS = 8047;

export const buildLocationParams = (searchLocation) => {
  if (
    searchLocation?.lat == null ||
    searchLocation?.lng == null ||
    Number.isNaN(Number(searchLocation.lat)) ||
    Number.isNaN(Number(searchLocation.lng))
  ) {
    return {};
  }

  const lat = Number(searchLocation.lat);
  const lng = Number(searchLocation.lng);

  return {
    location: `${lat},${lng}`,
  };
};

export const fetchLocationSuggestions = async (apiAddress, searchTerm) => {
  if (!searchTerm || searchTerm.trim().length < 2) {
    return [];
  }

  const response = await axios.get(
    `${apiAddress}/api/Location/GetLocationBySearchTerm`,
    { params: { searchTerm: searchTerm.trim() } },
  );

  return Array.isArray(response.data) ? response.data : [];
};

export const fetchLocationFromCoords = async (apiAddress, latitude, longitude) => {
  const response = await axios.get(`${apiAddress}/api/Location`, {
    params: { latitude, longitude },
  });

  return response.data;
};

export const normalizeLocationSelection = (location) => {
  if (!location) return null;

  const lat = location.latitude ?? location.lat;
  const lng = location.longitude ?? location.lng;

  if (lat == null || lng == null) return null;

  return {
    lat: Number(lat),
    lng: Number(lng),
    label:
      location.cityName ||
      location.name ||
      location.address ||
      `${Number(lat).toFixed(2)}, ${Number(lng).toFixed(2)}`,
  };
};

export const fetchSearchResults = async (
  apiAddress,
  { searchStr = "", searchLocation } = {},
) => {
  const locationParams = buildLocationParams(searchLocation);
  const trimmed = searchStr?.trim() || "";

  if (trimmed) {
    const response = await axios.get(
      `${apiAddress}/api/Search/GetSearchDataByString`,
      {
        params: {
          searchStr: trimmed,
          ...locationParams,
        },
      },
    );
    return response.data;
  }

  const response = await axios.get(
    `${apiAddress}/api/Search/GetSearchDataByNoString`,
    { params: locationParams },
  );

  return response.data;
};

export const formatSearchDistanceKm = (value) => {
  if (value == null || value === "") return null;

  const km = Number(value);
  if (Number.isNaN(km) || km < 0) return null;

  if (km < 1) {
    const meters = Math.round(km * 1000);
    return meters === 0 ? "< 1 m" : `${meters} m`;
  }

  return `${km.toFixed(1)} km`;
};
